import { AlertCircle, RefreshCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "./button";
import { TypographyH3 } from "./typography";

type Props = {
  message?: string;
  description?: string;
  retry?: () => void;
};

export const ErrorMessage = ({ message, description, retry }: Props) => {
  const { t } = useTranslation();

  const errorMessage = message || t("generic_error");

  const handleRetry = () => {
    if (retry) {
      retry();
    }
  };

  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="flex flex-col items-center justify-center text-center py-8 text-gray-500">
        <AlertCircle className="mx-auto h-10 w-10 mb-3 text-gray-400" />
        <p className="text-lg font-medium">{errorMessage}</p>
        {description && <p className="text-sm">{description}</p>}
        {retry && (
          <Button onClick={handleRetry} variant="ghost" className="gap-2 mt-1">
            <RefreshCcw size={16} />
            {t("retry")}
          </Button>
        )}
      </div>
    </div>
  );
};
